import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid'
import PropTypes from 'prop-types'
import Pagify from 'react-pagify'
import segmentize from 'segmentize'

const Paginator = ({ pagination, pages, onSelect }: any) => (
  <div className="">
    <Pagify.Context
      className="isolate inline-flex cursor-pointer -space-x-px rounded-md shadow-sm"
      segments={segmentize({
        page: pagination.page,
        pages,
        beginPages: 1,
        endPages: 1,
        sidePages: 1
      })}
      onSelect={onSelect}
    >
      {pagination.page === 1 ? (
        <div className="disabled sub-text relative inline-flex cursor-default items-center rounded-l-md border border-gray-300 bg-gray-100 text-sm font-medium text-gray-700 [&>*]:px-2 [&>*]:py-2">
          <div className="desktop">
            <ChevronLeftIcon className="h-5 w-5 text-gray-700" />
          </div>
        </div>
      ) : (
        <Pagify.Button
          className="clickable relative inline-flex items-center rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-20 [&>*]:px-2 [&>*]:py-2"
          page={pagination.page - 1}
        >
          <div className="desktop">
            <ChevronLeftIcon className="h-5 w-5 text-gray-700" />
          </div>
        </Pagify.Button>
      )}

      <Pagify.Segment
        field="beginPages"
        className="relative inline-flex items-center border border-gray-300 bg-white text-sm font-medium text-gray-700 empty:border-0 empty:p-0 hover:bg-gray-50 focus:z-20 [&>*]:px-4 [&>*]:py-2"
      />

      <Pagify.Ellipsis
        className="relative inline-flex cursor-default items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 empty:border-0 empty:p-0"
        previousField="beginPages"
        nextField="previousPages"
      />

      <Pagify.Segment
        className="clickable relative inline-flex items-center border border-gray-300 bg-white text-sm font-medium text-gray-700 empty:p-0 hover:bg-gray-50 focus:z-20 [&>*]:px-4 [&>*]:py-2"
        field="previousPages"
      />

      <div className="relative z-10 inline-flex items-center border border-blue-500 bg-blue-50 text-sm font-medium text-blue-600 focus:z-20 [&>*]:px-4 [&>*]:py-2">
        <span>{pagination.page}</span>
      </div>
      <Pagify.Segment
        className="clickable relative inline-flex items-center border border-gray-300 bg-white text-sm font-medium text-gray-700 empty:border-0 empty:p-0 hover:bg-gray-50 focus:z-20 [&>*]:px-4 [&>*]:py-2"
        field="nextPages"
      />

      <Pagify.Ellipsis
        className="ellipsis relative inline-flex cursor-default items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 empty:border-0 empty:p-0"
        previousField="nextPages"
        nextField="endPages"
      />

      <Pagify.Segment
        field="endPages"
        className="relative inline-flex items-center border border-gray-300 bg-white text-sm font-medium text-gray-700 empty:border-0 empty:p-0 hover:bg-gray-50 focus:z-20 [&>*]:px-4 [&>*]:py-2"
      />

      {pagination.page === pages ? (
        <div className="disabled sub-text relative inline-flex cursor-default items-center rounded-r-md border border-gray-300 bg-gray-100 text-sm font-medium text-gray-700 [&>*]:px-2 [&>*]:py-2">
          <div className="desktop">
            <ChevronRightIcon className="h-5 w-5 text-gray-700" />
          </div>
        </div>
      ) : (
        <Pagify.Button
          className="clickable relative inline-flex items-center rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-20 [&>*]:px-2 [&>*]:py-2"
          page={pagination.page + 1}
        >
          <div className="desktop">
            <ChevronRightIcon className="h-5 w-5 text-gray-700" />
          </div>
        </Pagify.Button>
      )}
    </Pagify.Context>
  </div>
)
Paginator.propTypes = {
  pagination: PropTypes.object.isRequired,
  pages: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default Paginator
